import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcnCarat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 37.233326,
	height: 16.413309,
	viewBox: "0 0 37.233326 16.413309",
	id: "svg1",
	"sodipodi:docname": "icn-carat.svg",
	"inkscape:version": "1.3.2 (091e20e, 2023-11-25)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs1" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview1",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:zoom": 4.9166667,
			"inkscape:cx": 18.610169,
			"inkscape:cy": 8.5423729,
			"inkscape:window-width": 1312,
			"inkscape:window-height": 449,
			"inkscape:window-x": 0,
			"inkscape:window-y": 38,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "svg1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "m 18.440245,16.413308 c -1.092,0 -2.152,-0.35 -3.072,-1.019 L 0.9142351,4.2173083 c -1.029,-0.795 -1.21699,-2.274 -0.42299,-3.30100002 0.796,-1.033 2.26899,-1.219 3.30099,-0.423 L 18.184245,11.624308 c 0.566,0.078 0.722,-0.033 0.774,-0.07 l 14.497,-11.02099972 c 1.035,-0.79 2.513,-0.584 3.298,0.449 0.787,1.03600002 0.585,2.51300002 -0.449,3.29700002 l -14.53,11.0449997 c -0.969,0.713 -2.106,1.082 -3.32,1.089 z",
			id: "path1"
		})
	]
});
export default SvgIcnCarat;
